<template>
  <div>
    <v-row class="modern-company-layout" no-gutters>
      <v-col cols="12" md="3" lg="2" class="sidebar-col">
        <v-card 
          elevation="0" 
          class="modern-sidebar h-100"
          rounded="xl"
        >
          <div class="sidebar-header">
            <h3 class="sidebar-title">شركة اجيال الوطن</h3>
            <div class="sidebar-divider"></div>
          </div>
          
          <v-list 
            class="modern-nav-list py-2" 
            nav 
            dense
          >
            <v-list-item
              v-for="(item, i) in items"
              :key="i"
              :class="['modern-nav-item', { 'active': selectedItem === i }]"
              @click="selectedItem = i"
              link
            >
              <v-list-item-icon class="modern-nav-icon">
                <v-icon :class="{ 'active-icon': selectedItem === i }">{{ item.icon }}</v-icon>
              </v-list-item-icon>
              
              <v-list-item-content>
                <v-list-item-title class="modern-nav-text">
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
              
              <div v-if="selectedItem === i" class="active-indicator"></div>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>

      <v-col class="content-col">
        <div class="modern-content-wrapper">
          <v-card elevation="0" class="modern-content-card" rounded="xl">
            <Box v-if="selectedItem == 0" />
            <Expenses v-if="selectedItem == 1" />
            <Income v-if="selectedItem == 2" />
            <Types v-if="selectedItem == 3" />
            <Benefit v-if="selectedItem == 4" />
            <Resource v-if="selectedItem == 5" />
            <Contract v-if="selectedItem == 6" />
          </v-card>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Box from "./../components/company/Box.vue";
import Expenses from "./../components/company/Expenses.vue";
import Income from "./../components/company/Income.vue";
import Types from "./../components/company/Types.vue";
import Benefit from "./../components/company/Benefit.vue";
import Resource from "./../components/company/Resource.vue";
import Contract from "./../components/company/Contract.vue";

export default {
  components: {
    Box,
    Benefit,
    Expenses,
    Types,
    Income,
    Resource,
    Contract,
  },
  data: () => ({
    selectedItem: 0,
    items: [
      { text: "الصندوق", icon: "mdi-safe" },
      { text: "المصروفات", icon: "mdi-trending-down" },
      { text: "الايرادات", icon: "mdi-trending-up" },
      { text: "التبويبات", icon: "mdi-view-grid-outline" },
      { text: "الجهات المستفيدة", icon: "mdi-account-group" },
      { text: "مصادر الايراد", icon: "mdi-source-branch" },
      { text: "عقود الشركة", icon: "mdi-file-document-multiple" },
    ],
  }),
};
</script>

<style scoped>
.modern-company-layout {
  min-height: calc(100vh - 88px);
  margin: 0;
}

.sidebar-col {
  padding: 0 12px 0 0;
}

.content-col {
  padding: 0;
}

.modern-sidebar {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  min-height: calc(100vh - 112px);
  position: sticky;
  top: 24px;
}

.sidebar-header {
  padding: 24px 20px 16px 20px;
}

.sidebar-title {
  font-size: 18px;
  font-weight: 700;
  color: #1F2937;
  margin: 0;
  text-align: center;
}

.sidebar-divider {
  height: 3px;
  background: linear-gradient(135deg, #0096Ab 0%, #00BCD4 100%);
  border-radius: 2px;
  margin-top: 12px;
  opacity: 0.8;
}

.modern-nav-list {
  padding: 8px 12px;
}

.modern-nav-item {
  margin: 4px 0;
  border-radius: 16px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  min-height: 48px;
}

.modern-nav-item:hover {
  background: rgba(0, 150, 171, 0.08) !important;
  transform: translateX(4px);
}

.modern-nav-item.active {
  background: linear-gradient(135deg, #0096Ab 0%, #00BCD4 100%) !important;
  color: white !important;
  box-shadow: 0 4px 16px rgba(0, 150, 171, 0.3);
  transform: translateX(8px);
}

.modern-nav-item.active::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0) 100%);
  pointer-events: none;
}

.modern-nav-icon {
  margin-right: 16px !important;
  min-width: 24px !important;
}

.modern-nav-icon .v-icon {
  font-size: 22px;
  color: #6B7280;
  transition: all 0.3s ease;
}

.modern-nav-item.active .modern-nav-icon .v-icon,
.modern-nav-item.active .modern-nav-text {
  color: white !important;
}

.modern-nav-text {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #374151 !important;
  transition: all 0.3s ease;
}

.active-indicator {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 24px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 2px;
}

.modern-content-wrapper {
  padding: 0 24px;
}

.modern-content-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  min-height: calc(100vh - 112px);
  overflow: hidden;
}

/* Responsive Design */
@media (max-width: 960px) {
  .sidebar-col {
    order: 2;
    padding: 12px 0 0 0;
  }
  
  .content-col {
    order: 1;
  }
  
  .modern-sidebar {
    position: static;
    min-height: auto;
    margin-bottom: 16px;
  }
  
  .modern-nav-list {
    display: flex;
    overflow-x: auto;
    padding: 8px;
  }
  
  .modern-nav-item {
    flex: 0 0 auto;
    margin: 0 4px;
    min-width: 120px;
  }
  
  .modern-content-wrapper {
    padding: 0 12px;
  }
}

@media (max-width: 600px) {
  .modern-content-wrapper {
    padding: 0 8px;
  }
  
  .sidebar-title {
    font-size: 16px;
  }
  
  .modern-nav-text {
    font-size: 12px !important;
  }
}
</style>
